import { STATUS_TYPE } from '../../../enum';
import { AddOnCategory } from '../../addonCategory/api/interface';
import { AddOnProduct } from '../../addonProduct/api/interface';

export interface GetAddOnProductVariant {
  id: string;
}

export interface FindAddOnProductVariant {
  search?: string;
  addonCategoryId?: string;

}

export interface CreatePatchAddOnProductVariant {
  id?: string;
  labelEn: string;
  labelAr: string;
  previewUrl: string;
  stock: string;
  price: string;
  addonCategoryId: string;
  addonProductId: string;
  position: string;
  activeState: boolean;
}

export interface AddOnProductVariant {
  id: string;
  labelEn: string;
  labelAr: string;
  previewUrl: string;
  stock: string;
  price: string;
  addonCategoryId: string;
  addon_category: AddOnCategory;
  addonProductId: string;
  addon_product: AddOnProduct;
  position: string;
  activeState: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: AddOnProductVariant[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
